import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useRef } from 'react';
import { useCombobox } from './useCombobox';
import { ComboboxSelectorDecorator } from './Elements/ComboboxSelectorDecorator';
import { ComboboxDropdown } from './Elements/ComboboxDropdown';
import { ComboboxDropdownItemDecorator } from './Elements/ComboboxDropdownItemDecorator';
import { TypographyLevel } from '../Typography/TypographyLevel';
import { Typography } from '../Typography/Typography';
export const Combobox = ({ isArrowVisible = true, options = [], value = null, isComboboxItemMode = false, disabled = false, autoFocus = false, classNameDropdown, classNameList, onValueChange, onClose }) => {
    var _a;
    const comboboxRef = useRef(null);
    const comboboxPopoverRef = useRef(null);
    const { isOpened, selectedItem, dropdownPosition, dropdownMinWidth, generateKey, toggleOpen, onSelect } = useCombobox({
        comboboxRef,
        comboboxPopoverRef,
        options,
        value,
        isComboboxItemMode,
        autoFocus,
        onValueChange,
        onClose
    });
    const text = (_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.text) !== null && _a !== void 0 ? _a : '';
    const renderItem = (itemText) => {
        return (_jsx(Typography, { level: TypographyLevel.BodyMd, noWrap: true, children: itemText }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(ComboboxSelectorDecorator, { ref: comboboxRef, isArrowVisible: isArrowVisible, disabled: disabled, selected: isOpened, "aria-label": text, onClick: toggleOpen, children: renderItem(text) }), _jsx(ComboboxDropdown, { ref: comboboxPopoverRef, comboboxRef: comboboxRef, isOpened: isOpened, position: dropdownPosition, minWidth: dropdownMinWidth, onOutsideClick: toggleOpen, classNameDropdown: classNameDropdown, classNameList: classNameList, children: options.map((item, index) => {
                    return (_jsx(ComboboxDropdownItemDecorator, { isSelected: item.value === value, onClick: () => onSelect(item), "aria-label": item.text, children: renderItem(item.text) }, generateKey(item, index)));
                }) })] }));
};
